import playingGif from '@/static/images/playing.gif';
import { VideoItemType, VideoLogParamsType, VideoType } from '@/types/camp/study/contentTypes';
import { formatSecondsToTime } from '@/utils';
import { postVideoLog } from '@/utils/requests/camp/requests_burying_point';
import {
  ContainerOutlined,
  FieldTimeOutlined,
  HourglassOutlined,
  PlayCircleFilled,
  RightOutlined,
} from '@ant-design/icons';
import cx from 'classnames';
import React, { useRef, useState } from 'react';
import { useRequest } from 'umi';
import styles from '../../css/studyIndexCSS.less';
import VideoPlayer from '../videoPlayer/videoPlayer';

interface props {
  videoList: VideoType;
  videoLogParams?: VideoLogParamsType;
  contentId?: string;
}

const Videos: React.FC<props> = ({ videoList, videoLogParams, contentId }) => {
  let initlUrl = '';
  let initlurrentTime = 0;
  let initPlayCurId = '';
  if (videoList.video && videoList.video.length > 0) {
    initlUrl = videoList.video[0].url;
    initlurrentTime = videoList.video[0].playSeconds;
    initPlayCurId = videoList.video[0].id;
  }
  const [playCurId, setPlayCurId] = React.useState<string>(initPlayCurId);
  const [playUrl, setPlayUrl] = React.useState(initlUrl);
  const [currentTime, setCurrentTime] = React.useState<number>(initlurrentTime);
  const [item, setItem] = React.useState<VideoItemType>(videoList.video[0]);
  const [isToggled, setIsToggled] = useState(false);
  const videoBoxRef = useRef<HTMLDivElement>(null);
  const [repeatLogId, setRepeatLogId] = React.useState<any>(null);

  const handlePlay = (item: VideoItemType) => {
    setPlayCurId(item.id);
    setPlayUrl(item.url);
    setCurrentTime(item.playSeconds);
    setItem(item);
  };

  const toggleStyle = () => {
    setIsToggled(!isToggled);
  };

  // 提交观看埋点
  const { run: postVideoLogRequest } = useRequest(
    (playSeconds: number, durationTime: number, logParams: any) => {
      const params = {
        playSeconds: playSeconds, // 当前播放进度（秒数）
        durationTime: durationTime, // 本次增量播放时长（秒数，从上次上报到本次上报）
        ...logParams,
      };

      return postVideoLog(params);
    },
    {
      manual: true,
      onSuccess: (res: any) => {
        if (!item?.logId) {
          item!.logId = res.id;
        }
        if (!repeatLogId) {
          setRepeatLogId(res.repeatLogId);
        }
      },
    },
  );

  return (
    <div className={styles.video_main}>
      <div style={{ flex: 1, height: 'auto' }} ref={videoBoxRef}>
        {playUrl ? (
          <VideoPlayer
            key={playCurId}
            url={playUrl}
            currentTime={currentTime}
            recordRequest={postVideoLogRequest}
            logParams={{
              batchId: videoLogParams?.batchId,
              nodeId: videoLogParams?.nodeId,
              nodeContentId: contentId,
              videoTotalTime: item?.duration,
              videoId: item?.id,
              id: item?.logId || null,
              repeatLogId: repeatLogId || null,
            }}
          />
        ) : (
          <div>暂无视频</div>
        )}
      </div>
      <div className={cx(styles.video_list_box_main, isToggled ? styles.fold_off : styles.fold_on)}>
        <div className={styles.fold} onClick={toggleStyle}>
          <RightOutlined className={styles.fold_icon} />
        </div>
        <div className={styles.vide_list_box}>
          <div className={styles.vide_list_title}>
            <span>
              <ContainerOutlined style={{ color: '#008bfe' }} />
            </span>
            <span>视频列表</span>
          </div>

          <div className={cx(styles.video_list)} style={{ height: '100%' }}>
            {videoList.video.map((item, index) => (
              <div
                key={index}
                className={styles.v_item}
                onClick={() => {
                  handlePlay(item);
                }}
              >
                <div className={styles.vlf}>
                  {playCurId === item.id ? (
                    <img alt={'playingGif'} src={playingGif} width={16} />
                  ) : (
                    <PlayCircleFilled className={styles.v_i_play} />
                  )}
                </div>
                <div className={styles.vrt}>
                  <div className={styles.vname}>{item.name}</div>
                  <div className={styles.vinfo}>
                    <div className="flex_1 f14 col808">
                      <div className="flex_1" style={{ gap: 4 }}>
                        <span>
                          <FieldTimeOutlined />
                        </span>
                        <span>{formatSecondsToTime(item.duration)}</span>
                      </div>
                      <div className="flex_1" style={{ gap: 4, marginLeft: 30 }}>
                        <span>
                          <HourglassOutlined />
                        </span>
                        <span>
                          {item.playSeconds >= item.duration ? (
                            '已看完'
                          ) : item.playSeconds > 0 ? (
                            <div>看至{Math.round((item.playSeconds / item.duration) * 100)}%</div>
                          ) : (
                            '未观看'
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Videos;
